import { Region, Location, IQueryString, objToQueryString } from './';

export class LocationPickerSelection implements IQueryString {
    constructor(public region?: Region, public locations?: Location[]) { }

    toQueryString() {
        let payload = {
            locations: this.locations ? this.locations.map(l => l.id).join(',') : []
        };

        return objToQueryString(payload);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/models/location-picker-selection.ts